import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import {Link} from "@mui/material";
import p_plesh from '../assets/images/p_plesh.png'

const auth = true;
const pages = [
    {
        text:'Home',
        link:'/',
        needAuth:false,
        ifAuth:true
    },
    {
        text:'Events',
        link:'/events',
        needAuth:true,
        ifAuth:true
    },
    {
        text:'Login',
        link:'/login',
        needAuth:false,
        ifAuth:false
    },
    {
        text:'Register',
        link:'/register',
        needAuth:false,
        ifAuth:false
    },
    {
        text:'Pricing',
        link:'/pricing',
        needAuth:false,
        ifAuth:false
    }
];
const settings = ['Profile', 'Logout'];

const ResponsiveAppBar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const Pages = ({pages}) => (
            auth ?
                pages.filter(page => page.needAuth === auth || page.ifAuth=== auth).map((page) => (
                    <MenuItem
                        key={page.text} onClick={handleCloseNavMenu}>
                        <Link href={page.link} underline={'none'}>
                            <Typography textAlign="center">{page.text}</Typography>
                        </Link>
                    </MenuItem>
                )) : pages.filter(page => page.needAuth === auth).map((page) => (
                    <MenuItem key={page.text} onClick={handleCloseNavMenu}>
                        <Link href={page.link} underline={'none'}>
                            <Typography textAlign="center">{page.text}</Typography>
                        </Link>
                    </MenuItem>
                ))
    )

    const PagesButton = ({pages}) => (
        auth ?
            pages.filter(page => page.needAuth === auth || page.ifAuth=== auth).map((page) => (
                <Button
                    key={page.text}
                    href={page.link}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: '#f1ebe9', display: 'block', textAlign:'center'}}
                >
                    {page.text}
                </Button>
            )) : pages.filter(page => page.needAuth === auth).map((page) => (
                <Button
                    key={page.text}
                    href={page.link}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: '#f1ebe9', display: 'block', textAlign:'center'}}
                >
                    {page.text}
                </Button>
            ))
    )

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                    >
                        LOGO
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            <Pages pages={pages}/>
                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
                    >
                        LOGO
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <PagesButton pages={pages}/>
                    </Box>
                    {
                        auth ? <Box sx={{ flexGrow: 0 }}>

                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar sx={{p: 0.7}} alt="Plesh" src={p_plesh} />
                                </IconButton>
                            </Tooltip>


                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseNavMenu}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box> : null
                    }

                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default ResponsiveAppBar;
